import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'
import constructRequestData from '../../constructRequestData'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Login.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'post /login': 200,
    // 'post /login/facebook': 200,
    // 'post /login/google': 200,
    // 'post /user/logout': 200,
  })
}

export const postAuthenticate = ({ mobile, clientId }) => {
  return client({
    method: 'post',
    url: '/authenticate',
    data: constructRequestData({ mobile, clientId }),
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })
}

export const postRequestOtp = ({ mobile, clientId, toMobile = false }) => {
  return client({
    method: 'post',
    url: '/authenticate/request-otp',
    data: constructRequestData({
      mobile,
      toMobile,
      clientId,
    }),
  })
}

export const postVerifyOtp = (
  { loginRequestId: requestId, code },
  fcmToken,
) => {
  const headers = {
    'X-Device-Id': generateDeviceId(),
    // 'Content-Type': 'application/x-www-form-urlencoded',
    // 'X-Client-Id': process.env.REACT_APP_CLIENT_ID,
    // 'X-Client-Secret': process.env.REACT_APP_CLIENT_SECRET,
  }

  if (fcmToken !== null) {
    headers['Fcm-Token'] = fcmToken
  }

  return client({
    method: 'post',
    url: '/authenticate/verify-otp',
    data: constructRequestData(
      {
        requestId,
        code,
        clientId: process.env.REACT_APP_CLIENT_ID,
      },
      // 'application/x-www-form-urlencoded',
    ),
    headers,
  })
}

//SOFT DELETE UNUSED API
export const postLogin = ({ username, password }, fcmToken) => {
  const headers = {
    'X-Device-Id': generateDeviceId(),
    'Content-Type': 'application/x-www-form-urlencoded',
    // 'X-Client-Id': process.env.REACT_APP_CLIENT_ID,
    // 'X-Client-Secret': process.env.REACT_APP_CLIENT_SECRET,
  }

  if (fcmToken !== null) {
    headers['Fcm-Token'] = fcmToken
  }

  return /* client({
    method: 'post',
    url: '/login',
    data: constructRequestData(
      {
        username,
        password,
        grantType: 'password',
        clientId: process.env.REACT_APP_CLIENT_ID,
      },
      'application/x-www-form-urlencoded',
    ),
    headers,
  }) */
}

export const postLoginWithGoogle = ({ token, fcmToken }) =>
  client({
    url: '/login/google',
    method: 'post',
    data: constructRequestData({
      clientId: process.env.REACT_APP_CLIENT_ID,
      token,
    }),
    headers: {
      'X-Device-Id': generateDeviceId(),
      'Fcm-Token': fcmToken,
    },
  })

export const postLoginWithApple = ({ token, code, fcmToken }) =>
  client({
    url: '/login/apple',
    method: 'post',
    data: constructRequestData({
      token,
      code,
      clientId: process.env.REACT_APP_CLIENT_ID,
    }),
    headers: {
      'X-Device-Id': generateDeviceId(),
      'Fcm-Token': fcmToken,
    },
  })

export const postLogout = ({ accessToken, refreshToken }) =>
  client({
    url: '/logout',
    method: 'post',
    data: constructRequestData({
      refreshToken,
      clientId: process.env.REACT_APP_CLIENT_ID,
    }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const postRequestCode = ({ accessToken, clientId }) =>
  client({
    url: '/token/code',
    method: 'post',
    data: constructRequestData({ clientId }),
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
  })
